import type { ToolContextMenuItem } from './type';

export const TOOL_CONTEXT_MENU_GROUP = {
  trackIDClipboard: {
    searchTrackID: {
      command: 'labeling.labelBox.trackIDSearch',
      disabled: false,
      hidden: false,
      shortcut: '',
    } as ToolContextMenuItem,
    copyTrackID: {
      command: 'labeling.labelBox.trackIDCopy',
      disabled: false,
      hidden: true,
      shortcut: '',
    } as ToolContextMenuItem,
    pasteTrackID: {
      command: 'labeling.labelBox.trackIDPaste',
      disabled: true,
      hidden: true,
      shortcut: '',
    } as ToolContextMenuItem,
    updateTrackID: {
      command: 'labeling.labelBox.trackIDUpdate',
      disabled: false,
      hidden: true,
      shortcut: '',
    } as ToolContextMenuItem,
  },

  boxClipboard: {
    copyBox: {
      command: 'labeling.labelBox.copyBox',
      disabled: false,
      hidden: true,
      shortcut: '',
    } as ToolContextMenuItem,
    pasteBox: {
      command: 'labeling.labelBox.pasteBox',
      disabled: true,
      hidden: false,
      shortcut: '',
    } as ToolContextMenuItem,
    deleteBox: {
      command: 'labeling.labelBox.removeBox',
      disabled: false,
      hidden: true,
      shortcut: '',
    } as ToolContextMenuItem,
  },

  boxNavigation: {
    focusPrevBox: {
      command: 'labeling.labelBox.focusPrevBox',
      disabled: false,
      hidden: true,
      shortcut: '',
    } as ToolContextMenuItem,
    focusNextBox: {
      command: 'labeling.labelBox.focusNextBox',
      disabled: false,
      hidden: true,
      shortcut: '',
    } as ToolContextMenuItem,
  },
} as const;
